/**
 * The backend stores money as integer minor units (kobo); the UI works in whole
 * Naira. These are the only two places the conversion should ever happen — at
 * the API boundary in the service layer.
 */

/** Naira (major) → kobo (minor), for request payloads. */
export function toMinorUnits(naira: number): number {
  return Math.round(naira * 100);
}

/** Kobo (minor) → Naira (major), for reading responses. */
export function fromMinorUnits(minor: number | string | null | undefined): number {
  if (minor === null || minor === undefined) return 0;
  return Math.round(Number(minor)) / 100;
}

export const VAT_RATE = 0.075;
